<template lang="pug">
  form.gl-img-upload(ref="form" enctype="multipart/form-data" novalidate)
    gl-btn(:options="{ label: 'Upload', type: 'button', style: 'smoke' }" @click.native="openFileReader")
    input(ref="input" @change="fileChanged($event.target.files[0])" accept="image/*" type="file")
</template>

<script>
export default {

  // props
  props: {
    options: Object
  },

  methods: {
    openFileReader () {
      // click input to open file reader
      this.$refs.input.click()
    },
    fileChanged (file) {
      // build file reader object
      let FR = new FileReader()

      // on file reader load
      FR.addEventListener('load', (e) => {
        // emit event w/ (e.target.result) base64
        this.$emit('base64', e.target.result)

        // reset input to ensure a change event fires if the same file's uploaded again
        this.$refs.form.reset()
      })

      // triggers the load listener
      FR.readAsDataURL(file)
    }
  }
}
</script>

<style lang="scss" scoped>
  .gl-img-upload {
    display: inherit;

    input {
      opacity: 0;
      width: 1px;
      height: 1px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/gl-img-upload.vue